import React from "react";
import { Box } from "Components/Base/Layout/Box";
import SnackbarAlert from "Components/Fragment/SnackbarAlert";
import { Typography } from "Components/Base/DataDisplay/Typography";

const NOTIFICATION_TYPE_SUCCESS = "success";
const NOTIFICATION_TYPE_ERROR = "error";
const NOTIFICATION_TYPE_INFO = "info";

export default class Notifier extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      notificationType: NOTIFICATION_TYPE_INFO,
      title: "",
      time: null,
      msg: "",
      hide: true,
    };
  }

  success(title, msg, time) {
    this.addNotify(title, msg, time, NOTIFICATION_TYPE_SUCCESS);
  }

  error(title, msg, time) {
    this.addNotify(title, msg, time, NOTIFICATION_TYPE_ERROR);
  }

  info(title, msg, time) {
    this.addNotify(title, msg, time, NOTIFICATION_TYPE_INFO);
  }

  addNotify(title, msg, time, notificationType) {
    this.setState({
      hide: false,
      title: title,
      msg: msg,
      time: time,
      notificationType: notificationType,
    });
  }

  hideNotification() {
    this.setState({ hide: true });
  }

  render() {
    const { hide, notificationType, title, msg } = this.state;
    const { hideHeader } = this.props;

    const displayTitle = !hideHeader && title !== "";

    if (!this.state || hide) return <div />;

    const html = { __html: msg };

    return (
      <SnackbarAlert
        open={!hide}
        severity={notificationType}
        message={
          <Box>
            <Typography variant="subtitle1" color="inherit">
              {displayTitle ? title : ""}
            </Typography>
            <Typography
              variant="caption"
              dangerouslySetInnerHTML={html}
              color="inherit"
            ></Typography>
          </Box>
        }
        onClose={() => this.hideNotification()}
      />
    );
  }
}
